import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/tooltip";
import { AlertTriangle, CheckCircle2 } from "lucide-react";

type DiagnosisStatusButtonProps = {
  isPassing: boolean;
  summary?: string;
  latestRunLabel?: string;
  onClick: () => void;
};

export function DiagnosisStatusButton({ isPassing, summary, latestRunLabel, onClick }: DiagnosisStatusButtonProps) {
  const ariaLabel = isPassing ? "No active diagnostic issues" : "Diagnostics runs have warnings";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={onClick}
          className="inline-flex rounded-md p-1 transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label={ariaLabel}
        >
          {isPassing ? (
            <CheckCircle2 className="h-4 w-4 text-green-600" />
          ) : (
            <AlertTriangle className="h-4 w-4 text-amber-500" />
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent>
        {isPassing ? (
          <>
            No active diagnostic issues.
            <br />
            Latest diagnostics run: {latestRunLabel || "Unknown run time"}
          </>
        ) : (
          summary || "Diagnostics checks have issues"
        )}
      </TooltipContent>
    </Tooltip>
  );
}
